import React from 'react';
import styled from '@emotion/styled';
import { ITheme } from '../../../ui';
import { useTranslation } from '../../shared/i18n/translate/useTranslation';
import { ICheckpointQueue } from '../domain/models/ICheckpointQueue';
import { useFormattedLastUpdatedTime } from './helpers/useFormattedLastUpdatedTime';
import themed from '../../../ui/themer/themed';

interface ILastUpdatedProps {
	checkpointQueues?: ICheckpointQueue[];
	isLoading?: boolean;
}

export const LastUpdated = ({
	isLoading,
	checkpointQueues,
}: ILastUpdatedProps) => {
	const { t } = useTranslation();
	const formattedLastUpdatedTime =
		useFormattedLastUpdatedTime(checkpointQueues);

	return (
		<LastUpdatedText isLoading={isLoading}>
			{t('web_security_checkpoint_last_updated', {
				time: formattedLastUpdatedTime,
			})}
		</LastUpdatedText>
	);
};

interface IStyledLastUpdatedProps {
	isLoading?: boolean;
}

const LastUpdatedText = styled.span<IStyledLastUpdatedProps, ITheme>`
	color: ${themed(({ shimmer, color }, { isLoading }) =>
		isLoading ? shimmer.placeholder.background : color.text.default,
	)};
`;
